import React, { useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { SideMenu } from '@shore/react-gravity';
import { useDispatch } from 'react-redux';
import { changeLocation } from '../../../actions';
import { useGlobals } from '@shared/contexts/GlobalsContext';
import EVENT_BUS_EVENTS from '../../../constants/event-bus-events';

const SIDE_MENU_CLICK_EVENT = 'side_menu_item_clicked';

export function FlatSideMenu() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { trackMethod, eventBus } = useGlobals();
  const [expandedItems, setExpandedItems] = useState<string[]>([]);

  const isPathActive = (paths: string[]) => {
    return paths.some((path) => {
      if (path === '/') {
        return location.pathname === '/' || location.pathname === '';
      }
      return location.pathname.startsWith(path);
    });
  };

  const handleNavigation = (path: string) => {
    // navigate(path);
    dispatch(changeLocation(path));
    trackMethod(SIDE_MENU_CLICK_EVENT, {
      platform: 'booking',
      location: 'side_menu_link',
      menu_item: path.replace(/#\/|\//g, ''),
    });
    eventBus.emit(EVENT_BUS_EVENTS.NAVIGATE, { payload: { route: path } });
  };

  const isSettingsExpanded = useMemo(() => {
    const isSettingsActive = isPathActive([
      '/settings',
      '/application-settings',
    ]);
    return isSettingsActive || expandedItems.includes('settings');
  }, [location.pathname, expandedItems]);

  const toggleSubmenuExpansion = (itemId: string) => {
    setExpandedItems((prev) =>
      prev.includes(itemId)
        ? prev.filter((id) => id !== itemId)
        : [...prev, itemId]
    );
  };

  return (
    <SideMenu
      title="Bookings"
      items={[
        {
          id: 'home',
          label: 'Home',
          isActive: isPathActive(['/home']),
          as: 'button' as const,
          onClick: () => handleNavigation('/home'),
        },
        {
          id: 'calendar',
          label: 'Calendar',
          isActive: isPathActive(['/calendar']),
          as: 'button' as const,
          onClick: () => handleNavigation('/calendar'),
        },
        {
          id: 'services',
          label: 'Services',
          isActive: isPathActive(['/services-v2']),
          as: 'button' as const,
          onClick: () => handleNavigation('/services-v2'),
        },
        {
          id: 'settings',
          label: 'Settings',
          isActive: isPathActive(['/application-settings']),
          as: 'button' as const,
          onClick: () => {
            if (isSettingsExpanded) {
              toggleSubmenuExpansion('settings');
            } else {
              handleNavigation('/application-settings');
              setExpandedItems((prev) => [...prev, 'settings']);
            }
          },
          isExpanded: isSettingsExpanded,
          submenu: [
            {
              id: 'booking_settings',
              label: 'Booking settings',
              isActive: isPathActive(['/application-settings']),
              as: 'button' as const,
              onClick: () => handleNavigation('/application-settings'),
            },
            {
              id: 'email_settings',
              label: 'Email settings',
              isActive: isPathActive(['/application-settings/notification']),
              as: 'button' as const,
              onClick: () =>
                handleNavigation('/application-settings/notification'),
            },
            {
              id: 'company_settings',
              label: 'Company settings',
              isActive: isPathActive(['/settings']),
              as: 'button' as const,
              onClick: () => handleNavigation('/settings'),
            },
          ],
        },
      ]}
    />
  );
}
